export const getPaywallsSubscribeUrl = (vanitySlug: string): string =>
  `https://anchor.fm/${vanitySlug}/subscribe`;
